module.exports = __webpack_public_path__ + "img/AnunciosdeYoutube.c5005645.svg";